import logo from '../assets/images/logo.png'

export function getWatermarkDataUrl() {
  return new Promise((resolve) => {
    try {
      const img = new Image()
      img.crossOrigin = 'anonymous'
      img.onload = () => {
        try {
          const canvas = document.createElement('canvas')
          canvas.width = img.naturalWidth || 400
          canvas.height = img.naturalHeight || 120
          const ctx = canvas.getContext('2d')
          if (!ctx) return resolve(null)

          ctx.filter = 'grayscale(100%)'
          ctx.globalAlpha = 0.08
          ctx.drawImage(img, 0, 0, canvas.width, canvas.height)

          resolve(canvas.toDataURL('image/png'))
        } catch (e) {
          console.warn('Watermark canvas error:', e)
          resolve(null)
        }
      }
      img.onerror = () => resolve(null)
      img.src = logo
    } catch (e) {
      resolve(null)
    }
  })
}
